import { CustomerAddStore } from './types'

export enum CustomerAddLocationKeys {
  ContactDetail = 'contactDetail',
  CustomerAdd = 'customerAdd',
  GuestOrderAddCustomer = 'guestOrderAddCustomer',
  GuestOrderAddDeparturePartner = 'guestOrderAddDeparturePartner',
  GuestOrderAddDestinationPartner = 'guestOrderAddDestinationPartner',
  OrderAddCustomer = 'orderAddCustomer',
  OrderAddDeparturePartner = 'orderAddDeparturePartner',
  OrderAddDestinationPartner = 'orderAddDestinationPartner'
}

export const ERRORS_CUSTOMER_DADATA_DISABLE_ADD_FORM = [
  {
    path: 'name',
    title: ''
  },
  {
    path: 'inn',
    title: ''
  },
  {
    path: 'kpp',
    title: ''
  }
]

export const ERRORS_ADDRESS_DADATA_DISABLE_ADD_FORM = [
  {
    path: 'address.zipCode',
    title: ''
  },
  {
    path: 'address.localityName',
    title: ''
  },
  {
    path: 'address.street',
    title: ''
  },
  {
    path: 'address.house',
    title: ''
  }
]
export const DEFAULT_CUSTOMER_ADD_ITEM = {
  customerInfo: {
    name: '',
    inn: '',
    kpp: '',
    legalAddress: '',
    address: {
      zipCode: '',
      localityName: '',
      street: '',
      house: '',
      flat: ''
    }
  },
  isDadataCustomerDisable: false,
  isDadataAddressDisable: false,
  selectedOptions: null,
  searchAddressValue: '',
  errorCompany: '',
  errorAddress: '',
  errorsCustomerDadataDisableAddForm: ERRORS_CUSTOMER_DADATA_DISABLE_ADD_FORM,
  errorsAddressDadataDisableAddForm: ERRORS_ADDRESS_DADATA_DISABLE_ADD_FORM,
  selectedAddress: null
}

export const initialState: CustomerAddStore = Object.values(CustomerAddLocationKeys).reduce((acc, key) => {
  acc[key] = { ...DEFAULT_CUSTOMER_ADD_ITEM }

  return acc
}, {} as CustomerAddStore)
